import { Table, Input, Button, Modal, Form, Rate } from "antd";
import React, {
  Component,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
// import TableGiveStarScore from '../Table_GiveStareScore/Table_GiveStarScore';
import Api from "../../services/ServiceApi";
import "./Modal_GiveStarScore.css";
import ModalSuccess from "../../components/Modal_Success";
import Cookies from "js-cookie";
let dataSource = [];
let initialFeedbackData = [];

// Create Editable Row
const EditableContext = React.createContext();
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const [rateEditing, setRateEditing] = useState(false);
  const inputRef = useRef();
  const starRef = useRef();
  // let isStar = true;
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  useEffect(() => {
    if (rateEditing) {
      starRef.current.focus();
    }
  }, [rateEditing]);
  // set the value every time var 'edtitng'  T <-> F
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const toggleEditRate = (e) => {
    setRateEditing(!rateEditing);
    form.setFieldsValue({
      [dataIndex]: e,
    });
  };
  // save for input box
  const save = async (e) => {
    try {
      const values = await form.validateFields();
      // console.log('values', values)
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  // save value for star rating
  const rateSave = async (e) => {
    try {
      // const values = await form.validateFields();
      const tempData = { performance: e };
      // console.log('e values', e, values, tempData)
      toggleEditRate(e);
      handleSave({ ...record, ...tempData });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    // console.log('childNode', childNode)
    if (typeof childNode[1] === "string") {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: false,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            placeholder={
              record.comment === "" ? "Please input" : record.comment
            }
          />
        </Form.Item>
      ) : (
          <div className="editable-cell-value-wrap" onClick={toggleEdit}>
            <Input
              ref={inputRef}
              onPressEnter={save}
              onBlur={save}
              placeholder={
                record.comment === "" ? "Please input" : record.comment
              }
            />
          </div>
        );
    } else {
      childNode = rateEditing ? (
        <Form.Item
          name={dataIndex}
          rules={[
            {
              required: false,
              message: "Rating Required",
            },
          ]}
        >
          <Rate
            ref={starRef}
            style={{ color: "#0719a3" }}
            onChange={rateSave}
          />
        </Form.Item>
      ) : (
          <div
            className="editable-cell-value-wrap"
          // onClick={toggleEditRate}
          >
            <Rate
              style={{ color: "#0719a3" }}
              className="editable-cell-value-wrap"
              ref={starRef}
              onChange={rateSave}
            >
              {children}
            </Rate>
          </div>
        );
    }
  }

  return <td {...restProps}>{childNode}</td>;
};

if (Cookies.get("job_id") !== undefined) {
  
}
class ModalGiveStarScore extends Component {
  constructor(props) {
    super(props);
    // constructor for table
    this.columns = [
      {
        title: "No.",
        dataIndex: "key",
        key: "key",
      },
      {
        title: "Job No.",
        dataIndex: "job_no",
        key: "job_no",
      },
      {
        title: "Assign No.",
        dataIndex: "seq_assign",
        key: "seq_assign",
      },
      {
        title: "Assigned",
        dataIndex: "assigned",
        key: "assigned",
      },
     
      {
        title: "Start Time",
        dataIndex: "startTime",
        key: "startTime",
      },
      {
        title: "Stop Time",
        dataIndex: "stopTime",
        key: "stopTime",
      },
      {
        title: "Remark",
        dataIndex: "remark",
        key: "remark",
      },
      {
        title: "Performance",
        dataIndex: "performance",
        key: "performance",
        editable: true,
        // render: (text, record, index) => {
        //   return (
        //     <Rate style={{color: "#0719a3"}} value={record.performance} />
        //     )
        // },
      },
      {
        title: "Comment",
        dataIndex: "comment",
        key: "comment",
        editable: true,
        // render: () => (
        //   <Input
        //     placeholder="Please input"
        //     value={this.state.comment}
        //     onChange={this.handleCommentChange}
        //   />
        // ),
      },
    ];
    this.state = {
      dataSource: [],
      modal_approve: false
    };
  }
 async componentDidMount(){
   this.setState({
    dataSource : []
   })
    // let promiseData = new Promise((resolve, reject) => {
      const get_data_emp = await Api.post("v2/get_data_emp_popup_approve", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_id: Cookies.get("job_id"),
      });
    //   resolve(data);
    // });
    // promiseData.then((res) => {
      // console.log("respond", res);
      let id = 0;
      if (get_data_emp.data.data === null) {
        get_data_emp.data.data = [];
      } else {
        get_data_emp.data.data.forEach((item) => {
          id++;
          let tempAssigned = "";
          if (item.team_id === null && item.emp_id === null) {
            tempAssigned = "-";
          } else if (item.team_id !== null && item.emp_id === null) {
            tempAssigned = item.team_name;
          } else {
            tempAssigned = item.emp_name;
          }
          let temp = {
            key: id,
            job_no: item.job_no, 
            seq_assign : item.seq_assign, 
            assigned: tempAssigned,
            startTime: item.assign_date.slice(11, 16),
            stopTime: item.update_date.slice(11, 16),
            performance: 0,
            comment: "",
            remark: item.remark === "" ? "-" : item.remark,
          };
          // tempState for component
          dataSource.push(temp);
          initialFeedbackData.push(item);
        });
      }
      this.setState({
        dataSource : dataSource
      })
      dataSource = [] ;
      // console.log('data', dataSource)
    // });
  }
  // save the data in each row
  handleSave = (row) => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    this.setState({
      dataSource: newData,
    });
  };
  // state = { visibleFromParent : true }
  handleCancel = (props) => {
    props.visible = false;
  };
  changeVisible = (visibleValue) => {
    this.props.handleVisible(visibleValue);
  };

  sendFeedback = async (props) => {
    const feedbackList = [];
    console.log("initial feedback data", initialFeedbackData);
    // build a response
  
    initialFeedbackData.forEach((i) => {
      console.log(i)
      const feedback = {
        company_id: Cookies.get('companyid'),
        operator_id: Cookies.get("operator_id"),
        project_id:Cookies.get('project_id'),
        // project_id: 1,
        team_group_id: i.team_group_id,
        job_id: i.job_id,
        job_progress_id : i.job_progress_id , 
        // job_id: 290,
        team_id: i.team_id,
        emp_id: i.emp_id,
        emp_name: i.emp_name,
        start_time: i.assign_date,
        job_assign_id: i.job_assign_id,
        stop_time: i.update_date,
        create_by:Cookies.get('username')
      };
      feedbackList.push(feedback);
    });

    // add performance and comment to the response using state data
    this.state.dataSource.forEach((item, index) => {
      feedbackList[index].performance = item.performance.toString();
      feedbackList[index].comment = item.comment;
    });

    const feedbackResponse = await Api.post(
      "v2/insert_emp_performance",
      feedbackList
    );
    if (feedbackResponse.data.result.code === "p") {
      const ApproveJob = await Api.post(
        "v3/update_oper_job_approve_finish",
        this.props.dataapprove
      );
      if (ApproveJob.data.result.code === "P") {
        // close the modal
        this.setState({
          modal_approve : true
        })
        // props.handleVisible(false);
        // window.location.reload();
      }
    }
  };
  render() {
    // let { visibleFromParent } = this.props
    const { dataSource } = this.state;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    // categorized editable and noneditable column
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      // pass record data to the cell
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    return (
      <>
        <Modal
          title="Performance"
          // centered
          destroyOnClose={true}
          visible={true}
          width={1000}
          onCancel={() => this.changeVisible(false)}
          footer={[
            <div className="text-center">
              <Button
                key="back"
                type="default"
                className="cancelButton"
                onClick={() => this.props.handleVisible(false)}
              >
                Cancel
            </Button>
              <Button
                key="submit"
                type="primary"
                className="confirmButton"
                onClick={() => this.sendFeedback(this.props)}
              >
                Confirm
            </Button>
            </div>,
          ]}
        >
          <div style={{height : "500px" , overflow: "auto"}}>
            <Table
              components={components}
              rowClassName={() => "editable-row"} 
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              
            />
          </div>
        </Modal>
        {this.state.modal_approve === true ?
          <ModalSuccess
            status="Approve Success"
            path_location={Api.absoluteUrl("/ma_list")}
          />
          : null
        }
      </>
    );
  }
}

export default ModalGiveStarScore;
